import { USER_ROLES } from 'constants/constants'; // dont remove this
import axiosClient from './axiosClient';

const reportApi = {
  // grid column
  advanceCreate: (data) => {
    const url = `advance-grid`;
    return axiosClient.post(url, data);
  },
  /**
   *
   * @param {{gridType: string}} parmas
   * @returns {Promise<{userGridColumn: null | Record<string, string>}>}
   */
  advanceGet: (params) => {
    const url = `advance-grid`;
    return axiosClient.get(url, { params });
  },

  advanceUpdate: (id, data) => {
    const url = `advance-grid/${id}`;
    return axiosClient.put(url, data);
  },

  advanceDelete: (id) => {
    const url = `advance-grid/${id}`;
    return axiosClient.delete(url);
  },

  // users
  getUsersSummaries: (param) => {
    const url = '/reports/users/summaries?' + new URLSearchParams(param);
    return axiosClient.get(url);
  },
  /**
   * course
   * @param {*} data
   * @param {*} params
   * @returns {Promise<{data: (import('./userApi').UserProps & {assignedCourses: number, completedCourses: number})[], userGridColumn: (null | Record<string, boolean>) } & import('components/React-table/commonCellAction').INIT_DATA >}
   */
  getUsersByPost: (data, { params, headers }) => {
    const url = `/reports/users`;
    return axiosClient.post(url, data, { params, headers });
  },

  /**
   * @param {*} data
   * @param {*} params
   * @returns {Promise<{data: TestReports[] & import('components/React-table/commonCellAction').INIT_DATA >}
   */
  getTestByPost: (data, { params, headers }) => {
    const url = `/report/get-report-test`;
    return axiosClient.post(url, data, { params, headers });
  },

  /**
   * @param {*} data
   * @param {*} params
   * @returns {Promise<CourseInfoProps[]>}
   */
  getDownloadCourseById: (data, { params }) => {
    const url = `/reports/courses`;
    return axiosClient.post(url, data, { params });
  },

  /**
   * test download by ids
   * @param {*} params
   * @returns {Promise<TestReports[] >}
   */
  getDownloadTestById: (data, params) => {
    const url = `report/get-report-test`;
    return axiosClient.post(url, data, { params });
  },
  getDownloadSurveyById: (id, data, params) => {
    const url = `/report/get-report-survey/${id}`;
    return axiosClient.post(url, data, { params });
  },
  getDownloadLiveclassById: (data, params) => {
    const url = 'reports/get-course-liveclasses-reports';
    return axiosClient.post(url, data, { params });
  },
  /**
   * assignment download by ids
   * @param {*} params
   * @returns {Promise<(TestReports & {total: number })[] >}
   */
  getDownloadAssignmentById: (data, { params }) => {
    const url = `/report/get-report-assignment`;
    return axiosClient.post(url, data, { params });
  },
  getDownloadScormById: (data, { params }) => {
    const url = `/report/get-report-scorm`;
    return axiosClient.post(url, data, { params });
  },
  getDownloadAttedanceById: (data, { params, urlId }) => {
    const url = `/session-users/${urlId}/users`;
    return axiosClient.post(url, data, { params });
  },

  getDownloadDemeritsById: (data, { params }) => {
    const url = '/course-centres';
    return axiosClient.get(url, { params });
  },

  /**
   * @param {{courseCentre: string[] | string, userType: keyof USER_ROLES, status: Omit<keyof COURSE_STATUS, "DELETED", page?: number, rowPerPage?: number> }} [params]
   * @returns {Promise<{data: import('./userApi').UserProps[], currentPage: number | null, totalPage: number , totalItems: number  } >}
   */

  getUsers: (params) => {
    const url = '/reports/users';
    return axiosClient.get(url, { params });
  },
  /**
   * @param {{courseCentre: string[] | string, userType: keyof USER_ROLES, status: Omit<keyof COURSE_STATUS, "DELETED", page?: number, rowPerPage?: number,  [x:string]: string> }} [params]
   * @returns {Promise<{data: import('./userApi').UserProps[], currentPage: number | null, totalPage: number , totalItems: number  } >}
   */
  getUsersPost: (params) => {
    const url = '/reports/users';
    return axiosClient.post(url, { params });
  },
  getReportUserById: (id, params) => {
    const url = `/reports/users/${id}`;
    return axiosClient.get(url, { params });
  },
  getReportUserCourse: (id, params) => {
    const url = `/reports/users/${id}/courses`;
    return axiosClient.get(url, { params });
  },
  getDownloadUserCourse: (id, data, params) => {
    const url = `/reports/users/${id}/courses`;
    return axiosClient.post(url, data, { params });
  },
  getUsersReportByPost: (data, { params, headers, urlId }) => {
    const url = `/reports/users/${urlId}/courses`;
    return axiosClient.post(url, data, { params, headers });
  },
  getClassReportByPost: (data, { params, headers, urlId }) => {
    const url = `/reports/courses/${urlId}/users`;
    return axiosClient.post(url, data, { params, headers });
  },
  getAssignmentReportByPost: (data, { params, headers, urlId }) => {
    const url = `/report/get-report-unit/${urlId}`;
    return axiosClient.post(url, data, { params, headers });
  },
  getLiveclassByPost: (data, { params, headers, urlId }) => {
    const url = `/session-users/${urlId}/users`;
    return axiosClient.post(url, data, { params, headers });
  },
  getScormbyPost: (data, { params, headers, urlId }) => {
    const url = `/report/get-report-unit/${urlId}`;
    return axiosClient.post(url, data, { params, headers });
  },
  //Chart details
  getDonutChartValue: (userID, params) => {
    const url = `/reports/users/${userID}`;
    return axiosClient.get(url, { params });
  },

  getBarChartValue: (params) => {
    const url = `/reports/get-user-courses-total-hours`;
    return axiosClient.get(url, { params });
  },

  //Watch Continue

  getWatchContinue: (params) => {
    const url = `/reports/user/get-recent-course`;
    return axiosClient.get(url, { params });
  },

  /**
   * Test reports
   * @param {*} params
   * @returns {Promise< {currentPage: number | null, totalItems: number, data: TestReports[], totalPage: number | null }>}
   */
  getTests: (params) => {
    const url = '/report/get-report-test';
    return axiosClient.get(url, { params });
  },
  exportTestResult: (unitID) => {
    const url = `/report/export-test-reports/${unitID}`;
    return axiosClient.get(url);
  },
  getInstructorReportTest: (id, params) => {
    const url = `reports/courses/${id}/get-course-test-reports`;
    return axiosClient.get(url, { params });
  },
  getReportTestId: (id, params) => {
    const url = `/report/get-report-test/${id}`;
    return axiosClient.get(url, { params });
  },
  getAllDetailReport: (id, params) => {
    const url = `/report/get-report-unit/${id}`;
    return axiosClient.get(url, { params });
  },
  /**
   *
   * @param {*} data
   * @param {{params?: Record<string, any>, headers?: Record<string, any>, urlId:string  }} params
   * @returns {Promise<{data: object[], currentPage: number | null, totalItems: number, totalPage: number  | null, courseInfo: object, unitInfo: object, userGridColumn: object | null}>}
   */
  getSurveyReportByPost: (data, { params, headers, urlId }) => {
    const url = `/report/get-report-unit/${urlId}`;
    return axiosClient.post(url, data, { params, headers });
  },
  getAllDetailReportDownload: (data, { params, urlId }) => {
    const url = `/report/get-report-unit/${urlId}`;
    return axiosClient.post(url, data, { params });
  },
  getReportTestIdDownload: (id, data, params) => {
    const url = `/report/get-report-test/${id}`;
    return axiosClient.post(url, data, { params });
  },
  getReportResultTest: (id) => {
    const url = `/report/get-report-test-detail/${id}`;
    return axiosClient.get(url);
  },

  getNewResult: (id) => {
    const url = `units/get-unit-tracking-details/${id}`;
    return axiosClient.get(url);
  },

  getTestReset: (params) => {
    const url = `/user-courses/reset-user-test-limit`;
    return axiosClient.get(url, { params });
  },
  /**
   *
   * @param {{[x: string] : string}} params
   * @returns {Promise<{currentPage : number | null , totalItems: number, totalPage: number, data: any[], questions: []}>}
   */
  getTestQuestion: (params) => {
    const url = `/report/get-test-questions-report`;
    return axiosClient.get(url, { params });
  },
  /**
   * assignments
   * @param {*} params
   * @returns {Promise< {currentPage: number | null, totalItems: number, data: TestReports[], totalPage: number | null }>}
   */
  getAssignments: (params) => {
    const url = '/report/get-report-assignment';
    return axiosClient.get(url, { params });
  },
  getInstructorReportAssignments: (id, params) => {
    const url = `reports/courses/${id}/get-course-assignment-reports`;
    return axiosClient.get(url, { params });
  },
  getDownloadReportAssignments: (data, { params, urlId }) => {
    const url = `reports/courses/${urlId}/get-course-assignment-reports`;
    return axiosClient.post(url, data, { params });
  },
  getReportAssignmentId: (id, params) => {
    const url = `/report/get-report-assignment/${id}`;
    return axiosClient.get(url, { params });
  },
  getReportAssignmentIdDownload: (id, data, params) => {
    const url = `/report/get-report-assignment/${id}`;
    return axiosClient.post(url, data, { params });
  },
  getReportResultAssignment: (id) => {
    const url = `/report/get-report-assignment-detail/${id}`;
    return axiosClient.get(url);
  },

  // surveys
  /**
   *
   * @param {*} params
   * @returns {Promise<object[] | data: object[]>}
   */
  getSurveys: (params) => {
    const url = '/report/get-report-survey';
    return axiosClient.get(url, { params });
  },
  getInstructorReportSurvey: (id, params) => {
    const url = `reports/courses/${id}/get-course-survey-reports`;
    return axiosClient.get(url, { params });
  },
  getDownloadReportSurvey: (id, data, params) => {
    const url = `reports/courses/${id}/get-course-survey-reports`;
    return axiosClient.post(url, data, { params });
  },

  getReportSurveyId: (id, params) => {
    const url = `/report/get-report-survey/${id}`;
    return axiosClient.get(url, { params });
  },
  getReportSurveyIdDownload: (id, data, params) => {
    const url = `/report/get-report-survey/${id}`;
    return axiosClient.post(url, data, { params });
  },
  getReportResultSurvey: (id) => {
    const url = `/report/get-report-survey-detail/${id}`;
    return axiosClient.get(url);
  },
  /**
   *
   * @param {{[x: string] : string}} params
   * @returns {Promise<{currentPage : number | null , totalItems: number, totalPage: number, data: any[], questions: []}>}
   */
  getSurveyQuestion: (params) => {
    const url = `/report/get-survey-questions-report`;
    return axiosClient.get(url, { params });
  },

  /**
   *
   * @param {{[x: string] : string}} params
   * @returns {Promise<{currentPage : number | null , totalItems: number, totalPage: number, data: any[], questions: []}>}
   */
  getSurveyQuestionByPost: (params) => {
    const url = `/report/get-survey-questions-report`;
    return axiosClient.post(url, { params });
  },

  // scorm
  getSCORMs: (params) => {
    const url = '/report/get-report-scorm';
    return axiosClient.get(url, { params });
  },
  getInstructorReportScorm: (id, params) => {
    const url = `reports/courses/${id}/get-course-scorm-reports`;
    return axiosClient.get(url, { params });
  },
  getDownloadReportScorm: (data, { params, urlId }) => {
    const url = `reports/courses/${urlId}/get-course-scorm-reports`;
    return axiosClient.post(url, data, { params });
  },
  getReportSCORMId: (id, params) => {
    const url = `/report/get-report-scorm/${id}`;
    return axiosClient.get(url, { params });
  },
  getReportSCORMIdDownload: (id, data, params) => {
    const url = `/report/get-report-scorm/${id}`;
    return axiosClient.post(url, data, { params });
  },
  getReportResultSCORM: (id) => {
    const url = `/report/get-report-scorm-detail/${id}`;
    return axiosClient.get(url);
  },

  // courses
  /**
   *
   * @param {*} params
   * @returns {Promise<{data: CourseInfoProps[], currentPage: number | null, totalItems: number, totalPage: number  | null}>}
   */
  getCourses: (params) => {
    const url = '/reports/courses';
    return axiosClient.get(url, { params });
  },

  getCoursesSummaries: (param) => {
    const url = '/reports/courses/summaries?' + new URLSearchParams(param);
    return axiosClient.get(url);
  },
  getInstructorCoursedetails: (id, params) => {
    const url = `/reports/courses/${id}/get-course-test-reports`;
    return axiosClient.get(url, { params });
  },
  getDownloadByTest: (data, { params, urlId }) => {
    const url = `/reports/courses/${urlId}/get-course-test-reports`;
    return axiosClient.post(url, data, { params });
  },
  getInstructorReportOverview: (id, params) => {
    const url = `/reports/courses/${id}/tracking-course-users`;
    return axiosClient.get(url, { params });
  },
  /**
   * @param {string} id
   * @param {Record<string, any>} params
   * @returns {Promise<{currentPage : number | null , totalItems: number, totalPage: number, data: Record<string, any>[], questions: []}>}
   */
  getCourseUser: (id, params) => {
    const url = `/reports/courses/${id}/users`;
    return axiosClient.get(url, { params });
  },
  /**
   * @param {any} data
   * @param {{params?: Record<string, any>, header?: Record<string, any>, urlId?: string  }} props
   * @returns {Promise<{currentPage : number | null , totalItems: number, totalPage: number, data: Record<string, any>[], questions: []}>}
   */

  getCourseUserByPost: (data, { params, header, urlId }) => {
    const url = `/reports/courses/${urlId}/users`;
    return axiosClient.post(url, data, { params, header });
  },
  getIntakeTestByPost: (data, { params, header, urlId }) => {
    const url = `/reports/courses/${urlId}/get-course-test-reports`;
    return axiosClient.post(url, data, { params, header });
  },
  getIntakeLiveclassByPost: (data, { params, header, urlId }) => {
    const url = 'reports/get-course-liveclasses-reports';
    return axiosClient.post(url, data, { params, header });
  },
  getIntakeCertificateByPost: (data, { params, header, urlId }) => {
    const url = `/course-certificates/user-certificates-by-intake/${urlId}`;
    return axiosClient.post(url, data, { params, header });
  },
  getIntakeAssignmentByPost: (data, { params, header, urlId }) => {
    const url = `reports/courses/${urlId}/get-course-assignment-reports`;
    return axiosClient.post(url, data, { params, header });
  },
  getIntakeScormByPost: (data, { params, header, urlId }) => {
    const url = `reports/courses/${urlId}/get-course-scorm-reports`;
    return axiosClient.post(url, data, { params, header });
  },
  getDownloadCourseUser: (data, { params, urlId }) => {
    const url = `/reports/courses/${urlId}/users`;
    return axiosClient.post(url, data, { params });
  },
  getCompleteCourseByAdmin: (id) => {
    const url = `/course-users/${id}/complete-course`;
    return axiosClient.get(url);
  },

  getCourseById: (id, params) => {
    const url = `/reports/courses/${id}`;
    return axiosClient.get(url, { params });
  },

  getLearnerEventLive: (params) => {
    const url = '/user-events/get-learner-events-live';
    return axiosClient.get(url, { params });
  },
  //live class
  getLiveclassReport: (params) => {
    const url = 'reports/get-course-liveclasses-reports';
    return axiosClient.get(url, { params });
  },
  getLiveclassReportByPost: (data, { params, headers }) => {
    const url = 'reports/get-course-liveclasses-reports';
    return axiosClient.post(url, data, { params, headers });
  },
  getDownloadCustomLiveclassReport: (data, { params }) => {
    const url = 'reports/get-course-liveclasses-reports';
    return axiosClient.post(url, data, { params });
  },
  getIntake: (id) => {
    const url = `/user-courses/get-unit?id=${id}`;
    return axiosClient.get(url);
  },
  /**
   *
   * @param {} event
   * @param {*} params
   * @returns {Promise<{data: AttendanceReportProps[], currentPage: number | null, totalItems: number, totalJoined: number, totalNotJoined: number, totalPage: number | null}>}
   */

  getLiveclassUser: (event, params) => {
    const url = `/session-users/${event}/users`;
    return axiosClient.get(url, { params });
  },
  /**
   *
   * @param {} event
   * @param {*} params
   * @returns {Promise<{data: AttendanceReportProps[], currentPage: number, totalItems: number, totalPage: number, userGridColumn: any }>}
   */

  getLiveclassUserbyPost: (data, { params, headers, urlId }) => {
    const url = `/session-users/${urlId}/users`;
    return axiosClient.post(url, data, { params, headers });
  },
  getLiveclassUserDownload: (data, { params, urlId }) => {
    const url = `/session-users/${urlId}/users`;
    return axiosClient.post(url, data, { params });
  },
  getJoinedCount: (params) => {
    const url = `/reports/get-course-liveclasses-reports-summaries`;
    return axiosClient.get(url, { params });
  },

  getlessons: (id, params) => {
    const url = `/user-events/get-user-events-by-course/${id}`;
    return axiosClient.get(url, { params });
  },
  getOverallReport: (data, { params }) => {
    const url = `/report/get-overall-report`;
    return axiosClient.post(url, data, { params });
  },
};

export default reportApi;

/**
 * Represents the course information with details about the time period, course centre, status, and other related attributes.
 *
 * @typedef {Object} CourseInfoProps
 * @property {Object} time - The time period for the course.
 * @property {string} time.begin - The start time of the course in ISO 8601 format.
 * @property {string} time.end - The end time of the course in ISO 8601 format.
 * @property {CourseCentre[]} courseCentre - The list of course centres associated with the course.
 * @property {string} status - The status of the course.
 * @property {number} totalIntakeTime - The total intake time for the course.
 * @property {number} totalEnrolledUsers - The total number of enrolled users in the course.
 * @property {number} totalPrice - The total price for the course.
 * @property {boolean} dashboardDisplay - Whether the course is displayed on the dashboard.
 * @property {string} _id - The unique identifier for the course.
 * @property {string} name - The name of the course.
 * @property {string} description - The description of the course in HTML format.
 * @property {string} code - The code of the course.
 * @property {Object} timezone - The timezone information for the course.
 * @property {string} timezone.name - The name of the timezone.
 * @property {string} timezone.value - The value of the timezone.
 * @property {string} teachingLanguage - The unique identifier for the teaching language of the course.
 * @property {object} thumbnail - images
 * @property {string} creator - The unique identifier for the creator of the course.
 * @property {Array} whiteBoardImages - The list of whiteboard images associated with the course.
 * @property {string} publishDate - The publish date of the course in ISO 8601 format.
 * @property {string} parent - The unique identifier for the parent course.
 * @property {string} updatedAt - The last updated date of the course in ISO 8601 format.
 * @property {string} rulesAndPath - The unique identifier for the rules and path associated with the course.
 * @property {number} index - The index of the course.
 * @property {number} assignedLearners - The number of learners assigned to the course.
 * @property {number} assignedInstructors - The number of instructors assigned to the course.
 * @property {number} completedLearners - The number of learners who have completed the course.
 * @property {number} inprogressLearners - The number of learners who are currently in progress in the course.
 * @property {number} activeLearners - The number of active learners in the course.
 */

/**
 * Attendance Reports
 *
 * @typedef {Object} AttendanceReportProps
 * @property {string} _id
 * @property {string} gradeStatus
 * @property {string} session
 * @property {Unit[]} unit
 * @property {Attendance} attendance
 * @property {Object[]} tracking
 * @property {CourseInfoProps[]} courses
 * @property {import('./userApi').UserPropsr[]} courseusers
 * @property {import('./userApi').UserProps} user
 */

/**
 * Test Reports
 * @typedef {Object} TestReports
 * @property {string} _id
 * @property {string} title
 * @property {string} status
 * @property {string} createdAt
 * @property {number} order
 * @property {number} testStarted
 * @property {number} compeleted
 * @property {number} failed
 * @property {number} inprogress
 * @property {number} graded
 * @property {number} reattempt
 * @property {number} avg_position
 * @property {string[]} courseUserNames
 * @property {CourseCentre[]} courseCentre
 * @property {CourseInfoProps} course
 */
